import * as configuration from '../../infrastructure/Configuration'
import {
  hotelService,
  availabilityService,
  labelsService, newRdHotelService, tripAdvisorService, newRdBookingService, newRdTrackingService, membersBenefitService, experienceAccumulatedPrice
} from '../infrastructure/Factory'
import { parseDate } from '../../domain/Parsers'
import Hotel from '../domain/Hotel'
import Currency from '../domain/Currency'
import AuthService from '../../services/AuthService'
import ExternalStorage from '@/services/ExternalStorage'
import FilterOption from '../domain/FilterOption'
import {
  appendData, buildBookingAnalytics,
  buildSearchAnalytics
} from '../../infrastructure/Analytics'
import { DateFactory } from 'rhg-vue-common'
import Filter from '../domain/Filter'
import Currencies from '@/domain/Currencies'
import { loadHotelJsonLd } from '@/infrastructure/Seo'

let passFirstFastRefresh = true

export default {
  listenToCustomerChanges ({ commit, dispatch }) {
    AuthService.onAuthenticated((customer, preventRefresh) => {
      commit('customer', customer)
      if (!preventRefresh || passFirstFastRefresh) {
        dispatch('refreshStays')
        passFirstFastRefresh = false
      }
    })
    AuthService.onUnauthenticated((anonymous, preventRefresh) => {
      commit('customer', anonymous)
      if (!preventRefresh) dispatch('refreshStays')
    })
  },
  async loadFirstTime ({ commit, getters, dispatch }) {
    const { hotelCode } = ExternalStorage.url.params

    commit('staysHasBeenLoading', true)
    await Promise.all([
      newRdHotelService.getHotel(hotelCode),
      newRdHotelService.getRooms(hotelCode)
    ]).then(async (data) => {
      const customer = AuthService.currentCustomer()
      commit('customer', customer)
      const jsonHotel = data[0]
      const jsonRooms = data[1]
      commit('jsonHotel', jsonHotel)
      commit('jsonRooms', jsonRooms)
      if (jsonHotel.coBrand) {
        dispatch('setCoBrandData', [jsonHotel.coBrand])
      }
      const labelsQubit = await experienceAccumulatedPrice.getLabelsQubit({
        hotelCode: jsonHotel.tmsCode
      })
      commit('SET_DATA_QUBIT', labelsQubit)
      // store temporal data unit finish full rates initialization to paint left section fast
      const hotel = Hotel.fromJSON(jsonHotel)
      commit('hotel', hotel)
      const filteredHotel = hotel
      const recalculatedFilter = Filter.empty()
      commit('applyFilter', { filteredHotel, recalculatedFilter })
      const preselectedFilters = {
        [FilterOption.MEMBER_ONLY]: getters.customer.isLogged || global.Utils.getURLParameter(`filter.${FilterOption.MEMBER_ONLY}`) === 'true',
        [FilterOption.POINTS]: global.Utils.getURLParameter(`filter.${FilterOption.POINTS}`) === 'true' || global.Utils.getURLParameter('paymentType') === 'onlyPointsAndCashPoints' || global.Utils.getURLParameter('paymentOption') === 'rdOnlyPointsAndCashPoints',
        [FilterOption.FREE_CANCELLATION]: global.Utils.getURLParameter(`filter.${FilterOption.FREE_CANCELLATION}`) === 'true',
        [FilterOption.BREAKFAST]: global.Utils.getURLParameter(`filter.${FilterOption.BREAKFAST}`) === 'true',
        [FilterOption.PACKAGES]: global.Utils.getURLParameter(`filter.${FilterOption.PACKAGES}`) === 'true',
        [FilterOption.ACCESSIBLE_ROOMS]: global.Utils.getURLParameter(`filter.${FilterOption.ACCESSIBLE_ROOMS}`) === 'true'
      }
      newRdHotelService
        .getStays(getters.customer, jsonHotel, jsonRooms, ExternalStorage.url.params, getters.taxIncludedRegion, getters.taxExcludedRegion, preselectedFilters)
        .then(({ hotel, filter }) => {
          sendWPAEvent(hotel)
          const { filteredHotel, recalculatedFilter } = hotel.applyFilter(filter, customer.isLogged)
          commit('applyFilter', { filteredHotel, recalculatedFilter })

          newRdHotelService.getCurrency(hotel.currency).then((response) => {
            commit('currenciesList', response)
            const exchangeRates = response.map(json => new Currency({
              code: json.currencyCode,
              name: json.currencyName,
              exchangeRate: json.exchangeRate
            }))

            Currencies.savePreferredCurrencyCodeIntoCookie()
            const currencies = Currencies.computeCurrencies(exchangeRates, Currencies.deductSelectedCurrencyCode(hotel.currency), hotel.currency)
            commit('exchangeRates', currencies)
            commit('hotel', hotel.changeCurrency(currencies.selectedOption))

            commit('staysHasBeenLoading', false)
            commit('staysHasBeenLoadedAtLeastOnce', true)

            commit('filteredHotel', getters.filteredHotel.changeCurrency(currencies.selectedOption))

            sendAnalytics(getters.filteredHotel, hotel, currencies, getters.taxIncludedRegion)

            const { checkInDate, checkOutDate } = ExternalStorage.url.params
            loadHotelJsonLd(jsonHotel, hotel.rooms, currencies?.selectedCurrency, checkInDate, checkOutDate)
          })
        })
        .catch((error) => {
          commit('staysHasBeenLoading', false)
          commit('error', Object.assign({}, error.response.data, { status: error.response.status }))
        })
    })

    tripAdvisorService
      .getRatingAndReviewsForHotel(hotelCode)
      .then((info) => {
        commit('tripAdvisorHotelInfo', info)
      })

    labelsService
      .getLabels()
      .then(({ labels }) => {
        global.tridionLabels = { ...configuration.tridionLabels || {}, ...labels }
        commit('labelsLoaded', true)
      })
    try {
      const benefits = await membersBenefitService.getMembersBenefits()
      commit('setMembersBenefits', benefits)
    } catch (error) {
      console.error(`membersBenefitService => ${error}`)
    }
  },
  refreshStays ({ commit, getters: { customer, hotel, filter, taxIncludedRegion, taxExcludedRegion, jsonHotel, jsonRooms, filteredHotel } }) {
    const alwaysRefresh = true // Always refresh when login or logout - EMMAWEB-2133
    if (alwaysRefresh || (hotel.tierDiscount && ExternalStorage.url.params.searchType === 'lowest')) {
      commit('staysHasBeenLoading', true)
      const preselectedFilters = {
        ...filter.selection(),
        [FilterOption.MEMBER_ONLY]: customer.isLogged
      }

      newRdHotelService
        .getStays(customer, jsonHotel, jsonRooms, ExternalStorage.url.params, taxIncludedRegion, taxExcludedRegion, preselectedFilters)
        .then(({ hotel, filter }) => {
          commit('applyFilter', hotel.applyFilter(filter, customer.isLogged))
          newRdHotelService
            .getCurrency(hotel.currency)
            .then((response) => {
              const exchangeRates = response.map(json => new Currency({
                code: json.currencyCode,
                name: json.currencyName,
                exchangeRate: json.exchangeRate
              }))

              Currencies.savePreferredCurrencyCodeIntoCookie()
              const currencies = Currencies.computeCurrencies(exchangeRates, Currencies.deductSelectedCurrencyCode(hotel.currency), filteredHotel.currency)
              commit('applyCurrency', currencies.selectedOption)
              commit('exchangeRates', currencies)
              commit('hotel', hotel)

              commit('staysHasBeenLoading', false)
              commit('staysHasBeenLoadedAtLeastOnce', true)

              sendAnalytics(filteredHotel, hotel, currencies, taxIncludedRegion)
            })
        })
        .catch((error) => {
          commit('error', Object.assign({}, error.response.data, { status: error.response.status }))
        })
    } else {
      if (customer.isLogged) {
        commit('applyFilter', hotel.applyFilter(filter.selectMemberOnly(), true))
      } else {
        commit('applyFilter', hotel.applyFilter(filter.unselectMemberOnly(), false))
      }
    }
  },
  applyFilter ({ commit, getters: { customer, hotel } }, filter) {
    const { filteredHotel, recalculatedFilter } = hotel.applyFilter(filter, customer.isLogged)
    commit('applyFilter', { filteredHotel, recalculatedFilter })
    newRdTrackingService.trackFilter(recalculatedFilter)
  },
  selectFilterOption ({ commit, getters: { customer, hotel, filter } }, option) {
    const { filteredHotel, recalculatedFilter } = hotel.applyFilter(filter.select(option), customer.isLogged)
    commit('applyFilter', { filteredHotel, recalculatedFilter })
    newRdTrackingService.trackFilter(recalculatedFilter)
  },
  unselectFilterOption ({ commit, getters: { customer, hotel, filter } }, option) {
    commit('applyFilter', hotel.applyFilter(filter.unselect(option), customer.isLogged))
  },
  unselectPointsFilter ({ commit, getters: { customer, hotel, filter } }) {
    commit('applyFilter', hotel.applyFilter(filter.unselectPoints(), customer.isLogged))
  },
  clearFilter ({ commit, getters: { customer, hotel, filter } }) {
    commit('applyFilter', hotel.applyFilter(filter.reset(), customer.isLogged))
  },
  changeCurrency ({ commit, getters }, selectedCurrency) {
    const hotel = getters.hotel.changeCurrency(selectedCurrency)
    const filteredHotel = getters.filteredHotel.changeCurrency(selectedCurrency)
    const currencies = getters.exchangeRates.selectOption(selectedCurrency)
    const categories = hotelCategories(filteredHotel)
    const lowestPricePerCategory = mapLowestPricePerCategory(filteredHotel, categories)
    newRdTrackingService.trackCurrency(selectedCurrency, lowestPricePerCategory)

    commit('hotel', hotel)
    commit('filteredHotel', filteredHotel)
    commit('exchangeRates', currencies)
    ExternalStorage.cookies.savePreferredCurrency(selectedCurrency)
  },
  async getNearbyHotels ({ commit, dispatch }) {
    const { hotelCode } = ExternalStorage.url.params
    const nearbyHotels = await newRdHotelService.getNearbyHotels(hotelCode)
    dispatch('getCobrandHotels', nearbyHotels)
    commit('nearbyHotels', nearbyHotels)
  },
  async acceptLoyaltyContent ({ commit }) {
    commit('loyaltyConsentAccepted', true)
  },
  async getCobrandHotels ({ commit }, hotels) {
    const coBrands = {}
    const cobrandHotels = hotels.filter((item) => item.coBrandCode).map((item) => item.coBrandCode)
    if (cobrandHotels.length > 0) {
      const coBrandImg = await newRdHotelService.getCoBrandImage(cobrandHotels)
      coBrandImg.images.forEach((item) => {
        coBrands[item.coBrand] = item
      })
    }
    commit('setCobrandHotels', coBrands)
  },
  // ***********************
  // LEGACY CODE BOTTOM HERE
  // ***********************
  async preBooking ({ commit, getters }, stay) {
    const customer = getters.customer
    const matchesSearch = getters.hotel.matchesSearch

    commit('bookingStayInProgress', stay)

    const { RK, searchType } = ExternalStorage.url.params
    const availabilityRequest = getAvailabilityRequest(customer)

    if (!(searchType !== 'lowest' && matchesSearch)) {
      availabilityRequest.searchType = 'lowest'
    }

    if (ExternalStorage.session.travelAgencyCustomerId()) {
      availabilityRequest.travelAgencyCustomerId = ExternalStorage.session.travelAgencyCustomerId()
    }

    if (ExternalStorage.session.promotionalCodeGroupId()) {
      availabilityRequest.promotionalCodeGroupId = ExternalStorage.session.promotionalCodeGroupId()
    }

    const siteIdCookie = ExternalStorage.cookies.siteId()
    const facilitatorIdCookie = ExternalStorage.cookies.facilitatorId()

    if (facilitatorIdCookie) {
      availabilityRequest.facilitatorId = facilitatorIdCookie
    }

    if (facilitatorIdCookie === 'ROOMKEY' && !siteIdCookie && RK) {
      availabilityRequest.merchantId = RK
    } else if (siteIdCookie) {
      availabilityRequest.merchantId = siteIdCookie
    }
    // commit('loadingStay', stay.identifier)

    try {
      const customerInfo = !customer.isAnonymous && customer.rewardsNumber ? customer : null
      const preBookingRes = await newRdBookingService.preBooking(availabilityRequest, stay.jsonForIntegrateWithApi, customerInfo)
      newRdBookingService.redirectToCheckout(preBookingRes)
    } catch (error) {
      commit('bookingStayInProgress', null)
      commit('error', Object.assign({}, error.response.data, { status: error.response.status }))
      // commit('loadingStay', undefined)
    }
  },
  clearError ({ commit }) {
    commit('error', undefined)
  },
  showError ({ commit }, error) {
    commit('error', error)
  },
  async setCoBrandData ({ commit }, coBrandKey) {
    const coBrandImg = await newRdHotelService.getCoBrandImage(coBrandKey)
    commit('coBrandImg', coBrandImg)
  }
}

export const getOccupancies = () => {
  // eslint-disable-next-line
  console.log('getting occupancy...');
  const params = new URLSearchParams(location.search)
  const adults = []
  const childrens = []
  const childrenV2 = []
  for (const [key, value] of params) {
    if (key === 'adults[]') {
      adults.push(parseInt(value))
    }
    if (key === 'children[]') {
      childrens.push(parseInt(value))
    }
    if (key === 'aoc[]' && !!value && value !== 'NaN') {
      childrenV2.push(value
        .split(',')
        .map(age => parseInt(age))
        .map(age => ({ age }))
      )
    }
  }
  return adults.map((adult, index) => ({
    adults: adult,
    children: childrens[index],
    childrenV2: childrenV2[index]
  }))
}

export const getAvailabilityRequest = (customer) => {
  let request = availabilityService.getPreviousAvailabilityRequest()
  const btnSearchSecondary = document.querySelector('.submit-search.btn-secondary')

  request = {
    ...request,
    occupancies: btnSearchSecondary ? request.occupancies : getOccupancies(),
    checkInDate: parseDate(request.checkInDate),
    checkOutDate: parseDate(request.checkOutDate)
  }
  if (!customer.isAnonymous) {
    request.tierDiscount = {
      tierType: customer.tier
    }
  }
  return request
}

export const sendAnalytics = async (filteredHotel, hotel, currencies, isTaxIncluded) => {
  let analyticsVariables = {}

  await Promise.all([
    hotelService.getHotelDistance(hotel.tmsCode),
    tripAdvisorService.getRatingAndReviewsForHotel(hotel.tmsCode)
  ]).then(async (data) => {
    if (data !== undefined) {
      analyticsVariables.hotelTripAdvisorRating = data[1]?.rating?.bubbleRating
      const distance = data[0][0]?.distance?.km
      analyticsVariables.searchHotelDistance = distance !== undefined ? parseFloat(distance)?.toFixed(2) : undefined
    }
  })

  const pricing = (stay) => {
    return ((stay.cash.hasCash()) ? (stay.cash.amountPerNight).toFixed(2) : '0.00') +
      '+' + (stay.points.hasPoints() ? stay.points.amountPerNight : '0')
  }
  const searchBarData = JSON.parse(localStorage.getItem('sb-last-viewed'))
  if (searchBarData) {
    const { place: srPlace, hotel: srHotel } = searchBarData
    analyticsVariables.searchTerm = srPlace ? srPlace?.name : srHotel?.name
    analyticsVariables.searchType = srPlace ? 'places' : 'hotels'
  }

  analyticsVariables.bookingStep = 'step2roomdisplay'
  const brandCode = hotel.subBrand && hotel.subBrand === 'ehl' ? hotel.subBrand : hotel.brandCode
  analyticsVariables.hotelBrandTheatre = `${brandCode} | ${hotel.theatre}`
  analyticsVariables.hotelName = hotel.name
  analyticsVariables.hotelCity = hotel.address?.cityCode
  analyticsVariables.hotelState = hotel.address?.stateCode
  analyticsVariables.hotelZip = hotel.address?.zip
  analyticsVariables.hotelCountry = hotel.address?.countryCode
  analyticsVariables.hotelCode = hotel.code
  analyticsVariables.isGlobalseo = hotel.globalSeo
  analyticsVariables.hotelCurrencyCode = hotel.currency
  analyticsVariables.isTaxesIncluded = isTaxIncluded

  analyticsVariables.searchHotelCode = hotel.code
  analyticsVariables.searchHotelBrand = hotel.brandCode?.toLowerCase()
  analyticsVariables.searchCity = hotel.address?.cityCode?.toLowerCase()
  analyticsVariables.searchState = `${hotel.address?.state?.toLowerCase()} - ${hotel.address?.countryCode}`
  analyticsVariables.searchCountry = hotel.address?.countryCode
  analyticsVariables.searchTheatre = hotel.theatre?.toLowerCase()
  analyticsVariables.searchResultsCities = hotel.address?.cityCode

  analyticsVariables = appendData(analyticsVariables, buildSearchAnalytics())
  analyticsVariables = appendData(analyticsVariables, buildBookingAnalytics())

  if (hotel.hasAvailableStays()) {
    analyticsVariables.isNoAvailabilityResults = 'false'
    analyticsVariables.searchResultsCount = '1'

    analyticsVariables.searchRateCodesDisplayed = hotel.rooms.reduce((acc, room) => [...acc, ...room.stays], [])
      .map(stay => stay.code)
      .join('|')

    analyticsVariables.bookingRoomTypeDisplayed = hotel.rooms
      .map(room => (room.name || '').toLowerCase())
      .join('|')

    const eur = currencies.getCurrencyByCode('EUR')
    analyticsVariables.searchHotelRateDisplayedPerNightRateEur = hotel.changeCurrency(eur).rooms.reduce((acc, room) => [...acc, ...room.stays], [])
      .map(stay => (stay) ? pricing(stay) : '')
      .join('|')

    const usd = currencies.getCurrencyByCode('USD')
    analyticsVariables.searchHotelRateDisplayedPerNightRateUsd = hotel.changeCurrency(usd).rooms.reduce((acc, room) => [...acc, ...room.stays], [])
      .map(stay => (stay) ? pricing(stay) : '')
      .join('|')

    const bookingRoomsRemaining = hotel.rooms
      .map(room => room.numberOfRooms)
      .filter(numberOfRooms => !isNaN(numberOfRooms))
      .join('|')
    if (bookingRoomsRemaining !== '') {
      analyticsVariables.bookingRoomsRemaining = bookingRoomsRemaining
    }
  } else {
    analyticsVariables.isNoAvailabilityResults = 'true'
    analyticsVariables.searchResultsCount = '0'
  }

  analyticsVariables.searchAvailabilityListHotels = hotel.tmsCode ? hotel.tmsCode : hotel.code + ((hotel.hasAvailableStays()) ? '-y' : '-n')

  analyticsVariables.lowestPrice = {
    currency: currencies.selectedOption.code,
    price: mapLowestPricePerCategory(filteredHotel, hotelCategories(filteredHotel))
  }
  const params = new URLSearchParams(window.location.search)
  analyticsVariables.bookingEcertCode = params.get('voucher')

  const devtools = localStorage.getItem('devtools-analytics-logs')
  if (devtools === 'shallow' || devtools === 'deep') {
    // eslint-disable-next-line no-console
    console.log('RD analytics: before buildViewData', global.utag_data, analyticsVariables)
  }
  global.trackingService.buildViewData(analyticsVariables)
  if (devtools === 'shallow' || devtools === 'deep') {
    // eslint-disable-next-line no-console
    console.log('RD analytics: before triggerAnalyticsEvent')
  }
  // global.trackingService.triggerAnalyticsEvent()
}

const sendWPAEvent = (hotel) => {
  const { checkInDate, checkOutDate, numberNights, searchType, promotionCode } = ExternalStorage.url.params
  const adults = (ExternalStorage.url.params.adults || []).map(it => `adults%5B%5D=${it}`)
  const children = (ExternalStorage.url.params.children || []).map(it => `children%5B%5D=${it}`)
  const occupancy = [...adults, ...children].join('&')

  global.WPA.requestPermission().then((client) => {
    client.sendEvent(
      new global.CartAbandonmentWPAEvent({
        firstName: global.AuthDispatcher.isLogged() ? global.AuthDispatcher.currentCustomer.firstName : null,
        hotelName: hotel.name,
        hotelCode: hotel.code,
        numberNights: checkInDate && checkOutDate
          ? DateFactory.daysBetween(checkInDate, checkOutDate)
          : numberNights || 1,
        searchType: searchType,
        promotionCode: promotionCode || null,
        occupancy: occupancy
      })
    )
  }).catch(() => { })
}

const hotelCategories = (filteredHotel) => {
  var categories = filteredHotel.rooms
    .map(room => room.stays
      .map(stay => stay.category)
    )
  // merge arrays into 1 array and delete repeated values
  return [].concat.apply([], categories).filter((value, index, self) => {
    return self.indexOf(value) === index
  })
}

const mapLowestPricePerCategory = (filteredHotel, categories) => {
  return categories.map(currentCategory => {
    return {
      [currentCategory === 'loyalty' ? 'rewards' : currentCategory]: parseFloat(filteredHotel.rooms
        .map(room => room.stays
          .filter(stay => stay.category === currentCategory && !stay.points.hasPoints())
          .map(stay => stay.cash.amountPerNight))
        .reduce((accumulator, currentValue) => accumulator.concat(currentValue), [])
        .reduce((minimumPrice, price) => price ? (price < minimumPrice ? price : minimumPrice) : minimumPrice, 0).toFixed(2))
    }
  })
}
